import React, {useContext, useEffect, useState} from 'react';

import AppStateContext from '../../context/appStateContext';
import GetCustomer from "../../../functions/GetCustomer";
import ApiStatus, {EMPTY,CALLING,POPULATED} from "../../../components/apiStatus";
import APIHelper from "../../../hooks/useAPIHelper";

import CustomerList from '../../components/Lists/customerList';
import ErrorBox from "../../../components/errorBox";

import { Background, ContentCtn, LogoutBtn, LogoImgCtn, PageHeader, SelectContractPage, GreetingHeader } from './index.style';
import { AngledBackground, LogoImg, FooterCtn, Spacer } from '../login/index.style';

import FooterImage from '../../../assets/images/hegLogo/logo.png';
import GetCallActionTypeCode from "../../../functions/GetCallActionTypeCode";
import brand from '../../../branding';

const SelectContract: React.FC<any> = (): React.ReactElement => {
  const { deleteUserRelatedState, contractList, setAppPageDetails,name, token, contactEmail, setAppStateDetails, updateCustomerInfoMap, siteLogo } = useContext(AppStateContext);

  const [customerData, setCustomerData] = useState([]);
  const [apiStatus, setApiStatus ] = useState(CALLING);

  const getCode = APIHelper();

  const getCenterCodes = async () => {
    let customers = [];

    const customerCallback = (data: {}) => {
      customers.push(data);
    };

    await Promise.all(Object.keys(contractList).map(async (customer) => {
      let filter = `<Parameters><CustomerCode>${customer}</CustomerCode></Parameters>`;
      await getCode.run(GetCustomer, customerCallback, [token, filter]);
    }));

    return customers
  };

  useEffect(() => {
    setAppPageDetails('selectContract');
    getCode.run(GetCallActionTypeCode, (data: []) => {
      setAppStateDetails({
        actionCodes: data
      })
    },[token]).then(() => {
      getCenterCodes().then( (data) => {
        if(data.length > 0) {
          setCustomerData(data);
          updateCustomerInfoMap(data);
          setApiStatus(POPULATED);
        } else {
          setApiStatus(EMPTY);
        }
      });
    })
  },[]);

  return (
    <SelectContractPage>
      <Background image={(brand.heroImages && brand.heroImages['selectContract']) || brand.heroImage || siteLogo.background_image[0]['image']['url']}>
        <Spacer />
        <ContentCtn>
          <div>
            <LogoutBtn
              type="button"
              onClick={(e): void => {
                e.preventDefault();
                deleteUserRelatedState();
              }}
            >
              Log out
            </LogoutBtn>
          </div>

          <LogoImgCtn>
            <LogoImg src={brand.logo || siteLogo.primary_logos[0]['image']['url']} alt="Client portal logo" />
          </LogoImgCtn>
          <GreetingHeader>Hello {name}</GreetingHeader>
          <PageHeader>Please select your site</PageHeader>
          {apiStatus == EMPTY && <ErrorBox
            text={<span>There are currently no sites assigned to you. <br/> Please contract {contactEmail}</span>}
            active={apiStatus == EMPTY}
          />}
          <ApiStatus type="bar" status={apiStatus} disable="empty"/>
          <CustomerList customerList={customerData}/>
          <FooterCtn fullWidth={brand.footerLogoFullWidth}>
            <img src={brand.footerLogo || FooterImage} srcSet={brand.footerLogo2x ? `${brand.footerLogo2x} 2x` : undefined} alt={brand.footerLogoAlt || 'HEG logo'} />
          </FooterCtn>
        </ContentCtn>

        <AngledBackground xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none">
          <polygon points="0,0 0,100 100,100" />
        </AngledBackground>
      </Background>
    </SelectContractPage>
  );
};

export default SelectContract;
